const defaultSuperScriptChars = ['‡', '®'];

/**
 * Our CMS ContentStack does not allow for HTML in all fields. Nonetheless, we still need to
 * show special characters via superscript tags to clearly communicate the intent of the character.
 * Accepts a text string and optional array of special characters, and returns a string with those
 * special characters wrapped in HTML <sup> tags.
 *
 * @type {{text: string, chars: array}}
 * @return superScriptText: string
 */
export const superScriptify = (text, chars = defaultSuperScriptChars) => {
  if (!text) return console.error('must provide text to superScriptify');
  let superScriptedText = text;
  chars.forEach((char) => {
    // use negative lookahead to only match char if a closing </sup> tag is not found
    // eslint-disable-next-line
    const re = new RegExp(`${char}(?!<\/sup>)`, 'g');
    superScriptedText = superScriptedText.replace(re, `<sup>${char}</sup>`);
  });
  return superScriptedText;
};
